import React, {Component} from 'react';
import _ from 'lodash';
// import {arrayOf, number, bool, string, func, object} from 'prop-types';
// import { Link } from 'react-router-dom';

import * as RouteHelpers from '../../helpers/routes';
import * as QuizHelpers from '../../helpers/quiz';

class Zip extends Component {
  // state = {
  //   zip: this.props.quiz.fieldValues,
  //   counties: this.props.rest.counties,
  //   county: '',
  //   loading: true,
  //   backBtn: false,
  //   mounted: false,
  //   animate: ''
  // };

  constructor (props) {
    super(props);
    this.state = {
      zip: this.props.quiz.fieldValues,
      counties: this.props.rest.counties,
      county: '',
      loading: true,
      backBtn: false,
      mounted: false,
      animate: ''
    };
    this._nextStep = this._nextStep.bind(this);
  }

  _validate (val = this.props.quiz.fieldValues.ZipCode) {
    const isValid = (val.length === 5);
    if (!isValid) RouteHelpers.updateStepIfDifferent(this.props.quiz.step);
    return isValid;
  }

  _isCountyEnabled (county, quizType) {
    console.log(quizType);
    if ((!_.isUndefined(county) && county.hasOwnProperty('City') && county.Individual !== false) && (
      quizType === 'Families' ||
      quizType === 'IndividualsFamilies')
    ) return true;

    return (county && county[quizType]);
  }

  _handleZipChange (zip) {
    if (zip.length <= 5) {
      const county = QuizHelpers._getCountyByZip(this.props.rest.counties, zip) || {};
      this.props.updateZip({zip, county});
      this.setState({ county });

      if (zip.length === 5) {
        if (county) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'county': county.County
          });
        } else {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'GAEvent',
            'eventCategory': 'Error',
            'eventAction': 'Inline',
            'eventLabel': 'Outside Service Area',
            'eventValue': undefined
          });
        }
      }
    }
  }

  _nextStep () {
    const {quiz, stepMethods} = _.clone(this.props);
    let nextStep = quiz.step + 1;

    // Western NY county data was skipping the next question (family size on most flows).
    // if (quiz.fieldValues.Location.loc.IsWesternNY === true) {
    //   console.log('WESTERN');
    //   nextStep++;
    // }

    stepMethods.setStep(nextStep);
  }

  componentDidMount () {
    const p = _.clone(this.props);
    const s = _.clone(this.state);
    const { quiz, location, route } = p;

    QuizHelpers.sendAnalyticsOnQuestion(`${p.route}`, 'Zip');

    p.toggleInQuiz(true);
    p.toggleInResults(false);
    p.updateResultsRatings(false, {});
    p.updateResultsFooter(false, {});
    p.setFieldValue('QuizRoute', `${p.route}`);

    if (window.location.search.indexOf('skip=true') > -1) {
      if (route === 'essential') {
        // update Family Type and Quote Type when skipping first step on essential:
        p.setFieldValue('FamilyType', 'Individual');
        p.setFieldValue('Quote', 'essential');
      } else if (route === 'medicaid') {
        // update Family Type and Quote Type when skipping first step on essential:
        p.setFieldValue('FamilyType', 'Individual');
        p.setFieldValue('Quote', 'medicaid');
      }
    }

    if (p.route === 'child-health-plus' &&
      p.quiz.fieldValues.Quote !== 'child-health-plus') {
      p.setFieldValue('Quote', 'child-health-plus');
    }
    if (this.props.route === 'medicare' && this.props.quiz.fieldValues.Medicare !== 'true') {
      this.props.setFieldValue('Medicare', true);
    }

    window.scrollTo(0, 0);
    _.merge(s, {mounted: true});
    if (location && location.loc) _.merge(s, {county: location.loc});
    if (quiz.step > 1) _.merge(s, {backBtn: true});

    this.setState(s);

    setTimeout(() => {
      this.setState({
        animate: 'fadeIn'
      });
    }, 600);
  }

  componentWillUnmount () {
    this.setState({mounted: false});
  }

  render () {
    const p = _.clone(this.props);
    const {
      quiz,
      rest,
      countyKey
    } = p;
    const values = quiz.fieldValues;
    const s = _.clone(this.state);
    const loading = rest.counties.length ? '' : ' loading';
    let {county} = s;

    if (quiz.fieldValues.ZipCode.length && county === '') {
      county = QuizHelpers._getCountyByZip(
        this.props.rest.counties, quiz.fieldValues.ZipCode
      ) || {};
    }

    let isEnabled = !!county && this._validate(values.ZipCode);
    let notice;

    if (quiz) { // Don't load the view until the quiz data is propped in
      if (isEnabled) {
        if (county && this._isCountyEnabled(county, this.props.countyKey)) {
          if (this.props.quiz.fieldValues.Quote === 'small-business') {
            notice = <p className='check'>We love <strong>{this.state.county.City}</strong> businesses!</p>;
          } else {
            notice = <p className='check'><strong>{county.City}</strong> is lucky to have you!</p>;
          }
        } else {
          switch (countyKey) {
            case 'SmallBusiness':
              notice = <p className='alert'>Unfortunately, we don&rsquo;t offer Group health plans in your area, but you<br /> can always visit <a href='https://www.healthcare.gov/small-business/' target='_blank' rel='noopener noreferrer'>HealthCare.gov</a> to find Small Business coverage.</p>;
              isEnabled = false;
              break;

            case 'Medicare':
              notice = <p className='alert'>Unfortunately, we don&rsquo;t offer Medicare Advantage plans in your area.<br /> We invite you to use the <a href='https://www.medicare.gov/find-a-plan/questions/home.aspx' target='_blank' rel='noopener noreferrer'>government&rsquo;s Plan Finder</a>.</p>;
              isEnabled = false;
              break;

            case 'Medicaid':
              notice = <p className='alert'>You may be eligible for Medicaid. Unfortunately, we don&rsquo;t offer Medicaid plans in your area,<br /> but you can always visit the <a href='https://nystateofhealth.ny.gov/' target='_blank' rel='noopener noreferrer'>New York State of Health</a> to find coverage.</p>;
              isEnabled = false;
              break;

            case 'Essential':
              notice = <p className='alert'>You may be eligible for a New York Essential Plan. Unfortunately, we don&rsquo;t offer Essential plans in your area,<br /> but you can always visit the <a href='https://nystateofhealth.ny.gov/' target='_blank' rel='noopener noreferrer'>New York State of Health</a> to find coverage.</p>;
              isEnabled = false;
              break;

            default:
              notice = <p className='alert'>Unfortunately, we don&rsquo;t offer health plans in your area, but you<br /> can always visit the <a href='https://nystateofhealth.ny.gov/' target='_blank' rel='noopener noreferrer'>New York State of Health</a> to find coverage.</p>;
              isEnabled = false;
              break;
          }
        }
      }

      let back = s.backBtn ? (<button className='btn back' onClick={this.props.stepMethods.prevStep}>Previous</button>) : null;

      return (
        <section className={'p30 animate ' + this.state.animate + loading}>
          <div className='wrap text-center'>
            <h3>What’s your zip code?</h3>
            <p className='form'>
              <input
                id='ZipCode'
                autoFocus
                type='number'
                ref={(input) => { this.zip = input; }}
                name='ZipCode'
                placeholder='XXXXX'
                maxLength='5'
                value={quiz.fieldValues.ZipCode}
                onKeyUp={(e) =>
                  (e.which === 13 &&
                    isEnabled &&
                    this.props.stepMethods.isNextStep() &&
                    this._nextStep()
                  )
                }
                onChange={(e) => this._handleZipChange(e.target.value)}
              />
              {this.props.stepMethods.isNextStep() &&
              <button
                className={'btn next ' + isEnabled}
                disabled={!isEnabled}
                onClick={this._nextStep}>Next</button>}
              {back}
            </p>
            <div className={'message' + (notice ? ' show' : '')}>
              {notice}
            </div>
          </div>
        </section>
      );
    }

    return <section className={'p30' + loading} />;
  }
}

Zip.propTypes = { // validate props expected
};

export default Zip;